import { IonContent, IonPage, IonSearchbar, IonHeader, IonSpinner, useIonViewDidEnter } from '@ionic/react';
import React, { useEffect, useRef, useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './BibleStudyBrowser.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import ReadingPlanRecordService from '../../services/ReadingPlanRecordService';
import { useDispatch, useSelector } from 'react-redux';
import { SelectActiveReadingPlanRecord, SelectActiveSession, SelectLastVersion, SelectScheduledSession, UpdateActivePlanByIdAsync, UpdateActiveReadingPlanRecord } from '../../store/BibleStudySlice';
import SessionLink from './SessionLink';
import { Virtuoso, VirtuosoHandle } from 'react-virtuoso';
import { SelectGroupIds } from '../../store/FellowshipSlice';

const BibleStudyBrowser: React.FC<IRouteInfo> = (props:IRouteInfo) => {
  const dispatch = useDispatch();
  const currentReadingSession = useSelector(SelectActiveSession);
  const scheduledReadingSession = useSelector(SelectScheduledSession);
  const lastVersion = useSelector(SelectLastVersion);
  const currentSessionElement = useRef<HTMLDivElement>(null);
  const pageContent = useRef<HTMLIonContentElement>(null);
  const scrollToDay = useRef(true);
  const [searchText, setSearchText] = useState('');
  const sessionListRef = useRef<VirtuosoHandle | null>(null);
  const [sessionListKey, setSessionListKey] = useState('sessionList-init');
  const sessionListContainer = useRef<HTMLDivElement>(null);
  const ActiveReadingPlanRecord = useSelector(SelectActiveReadingPlanRecord);
  const userGroupsIds = useSelector(SelectGroupIds);

  useIonViewDidEnter(() => {
    scrollToDay.current = true;
    setSearchText('');

    if(!ActiveReadingPlanRecord) {
      UpdateActivePlanByIdAsync(dispatch, userGroupsIds);
    }
    // Reload Session List one second after initial load
    // Fixes mysterious issue with links not working on initial load
    // and make the table scroll to current day.
    console.log('classesPre1', sessionListContainer.current?.classList);
    setTimeout(() => {
      setSessionListKey('sessionList-reload' + Math.random().toString());
    }, 1000);
  },[ActiveReadingPlanRecord]);

  useEffect(() => {
    pageContent.current?.scrollToTop();
  }, [searchText]);

  const updateSessionCompletion = (checked: boolean, index: number) => {
    const updatedSessions = [...ActiveReadingPlanRecord?.completedSessions!];
    const updatedRecord = {...ActiveReadingPlanRecord!};
    updatedSessions[index] = !checked;
    updatedRecord.completedSessions = updatedSessions;
    dispatch(UpdateActiveReadingPlanRecord(updatedRecord));
    ReadingPlanRecordService.updateReadingPlanRecord(updatedRecord).then(result => console.log(result));
  }

  // USED TO GENERATE LIST WHEN SEARCH IS ACTIVE
  const createReadingPlanList = () => {
    const readingPlanList = ActiveReadingPlanRecord?.completedSessions
      .map((session, index) => ({sessionNumber: index + 1, checked: session}))
      .filter(session => searchText ? session.sessionNumber.toString().includes(searchText): true);
    return readingPlanList?.map(session => {
      const prevHighlightedIndexed = session.sessionNumber === (scheduledReadingSession - 1) ? true : false;
      const scheduledSessionIndexed = session.sessionNumber === scheduledReadingSession ? true : false;
      const currentSessionIndexed = session.sessionNumber === currentReadingSession?.session ? true : false;
      return (
        <SessionLink
          key={`session-${session.sessionNumber}`}
          checked={session.checked}
          sessionNumber={session.sessionNumber}
          planCode={ActiveReadingPlanRecord?.readingPlanCode!}
          version={lastVersion ?? 'esv'}
          currentSessionRef={currentSessionIndexed ? currentSessionElement : null}
          scheduledSessionIndexed={scheduledSessionIndexed}
          prevHighlightedIndexed={prevHighlightedIndexed}
          acceleratedPace={ActiveReadingPlanRecord ? ActiveReadingPlanRecord.sessionsPerDay > 1 : false}
          updateSessionCompletion={updateSessionCompletion} />
      );
    });
  }

  // USED TO GENERATE LIST WHEN BROWSING WITHOUT SEARCH ACTIVE
  const sessionItem = (sessionNumber: number) => {
    const checked = ActiveReadingPlanRecord?.completedSessions[sessionNumber - 1];

      const prevHighlightedIndexed = sessionNumber === (scheduledReadingSession - 1) ? true : false;
      const scheduledSessionIndexed = sessionNumber === scheduledReadingSession ? true : false;
      const currentSessionIndexed = sessionNumber === currentReadingSession?.session ? true : false;
      return (
        <SessionLink
          key={`session-${sessionNumber}`}
          checked={checked!}
          sessionNumber={sessionNumber}
          planCode={ActiveReadingPlanRecord?.readingPlanCode!}
          version={lastVersion ?? 'esv'}
          currentSessionRef={currentSessionIndexed ? currentSessionElement : null}
          scheduledSessionIndexed={scheduledSessionIndexed}
          prevHighlightedIndexed={prevHighlightedIndexed}
          acceleratedPace={ActiveReadingPlanRecord ? ActiveReadingPlanRecord.sessionsPerDay > 1 : false}
          updateSessionCompletion={updateSessionCompletion} />
      );
  }


  return (
    <IonPage id="browse-page">
        <PageHeader {...props} ></PageHeader>
        <IonHeader mode="md" className="browse-search-header">
          <IonSearchbar 
            value={searchText} 
            placeholder="Search By Day Number" 
            type="number" 
            inputmode="numeric" 
            onIonChange={e => setSearchText(e.detail.value?.toString()!)}
            className="search-box-browser" />
        </IonHeader>
        <IonContent id="browse-content" color="light">
          <div className="browse-grid">
            {
              ActiveReadingPlanRecord?.completedSessions.length ?
                searchText ?
                  createReadingPlanList() :
                  <div ref={sessionListContainer} className="session-list-animation">
                    <Virtuoso
                      key={sessionListKey}
                      ref={sessionListRef}
                      initialTopMostItemIndex={currentReadingSession?.session ? currentReadingSession.session - 1 : scheduledReadingSession ? scheduledReadingSession - 1 : 0}
                      style={{ height: '100%' }}
                      totalCount={ActiveReadingPlanRecord?.completedSessions.length}
                      itemContent={index => sessionItem(index + 1)}
                    />
                  </div>  :
                  <div className="browser-loading-days">
                    <IonSpinner name="dots" color="medium" />
                    <p className="loading-text">LOADING DAYS</p>
                  </div>
            }
          </div>
        </IonContent>
    </IonPage>
  );
};

export default BibleStudyBrowser;